import styled from "styled-components";
import { colours } from "../../styles/colours.constants";
import { satoshi500 } from "../../styles/font.constants";

export const ToolbarDropdownMenu = styled.div<{ $align?: "left" | "right" }>`
	position: absolute;
	top: calc(100% + 0.5rem);
	${({ $align }) => ($align === "right" ? "right: 0;" : "left: 0;")}
	z-index: 1000;
	width: max-content;
	min-width: 10.625rem;
	background: ${colours.black}E2;
	border-radius: 24px;
	padding: 1rem;
	box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
	display: flex;
	flex-direction: column;
	gap: 0.8rem;
`;

export const DropdownItem = styled.button`
	display: flex;
	gap: 0.5rem;
	align-items: center;
	justify-content: flex-start;
	border: none;
	background: none;
	width: 100%;
	padding: 0;
	white-space: nowrap;
	cursor: pointer;

	&:hover {
		div {
			color: ${colours.greyDark};
		}
		svg {
			stroke: ${colours.greyDark};
		}
	}
`;

export const Label = styled.div`
	${satoshi500}
	color: ${colours.white};
	font-size: 0.875rem;
	white-space: nowrap;
	cursor: pointer;
`;
